export default class Permission {
  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        permissionList {
          results {
            id
            name
            codename
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.permissionList.results.reverse();
  }
}